var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.09091C0 1.48484 0.202708 0.984836 0.608108 0.590909C1.01351 0.196964 1.54055 0 2.18919 0C2.82626 0 3.34169 0.193927 3.73552 0.581818C4.14092 0.981818 4.34363 1.50302 4.34363 2.14545C4.34363 2.72727 4.14672 3.21211 3.7529 3.6C3.3475 4 2.81467 4.2 2.15444 4.2H2.13707C1.49999 4.2 0.984562 4 0.590734 3.6C0.196905 3.2 0 2.69696 0 2.09091ZM0.225869 18V5.85455H4.08301V18H0.225869ZM6.22008 18H10.0772V11.2182C10.0772 10.7939 10.1236 10.4667 10.2162 10.2364C10.3784 9.82424 10.6245 9.47575 10.9546 9.19091C11.2847 8.90605 11.6988 8.76364 12.1969 8.76364C13.4942 8.76364 14.1429 9.67878 14.1429 11.5091V18H18V11.0364C18 9.24242 17.5946 7.88182 16.7838 6.95455C15.973 6.02727 14.9015 5.56364 13.5695 5.56364C12.0753 5.56364 10.9112 6.23636 10.0772 7.58182V7.61818H10.0598L10.0772 7.58182V5.85455H6.22008C6.24324 6.24242 6.25483 7.44847 6.25483 9.47273C6.25483 11.497 6.24324 14.3394 6.22008 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.d4d9da92d203896d8b193db979381d0a.svg";
export { ForwardRef as ReactComponent };